// GLOBAL THEME JS

// DOM SELECTION 

// Search Bar Wrapper 
const searchWrapper = document.querySelector('.header-search-bar--wrapper');
const searchInner = document.querySelector('.search-inner');

//Functions Site Wide

// Header Mobile

const mobNavAcc = document.getElementsByClassName("accordion-mobile");

for (i = 0; i < mobNavAcc.length; i++) {
  mobNavAcc[i].onclick = function() {

	if( !this.classList.contains('active') ){
    	closeAll();
    }
	
  this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight){
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
  
}

function closeAll(){
	 for (i = 0; i < mobNavAcc.length; i++) {
    	mobNavAcc[i].classList.remove("active");
        mobNavAcc[i].nextElementSibling.style.maxHeight = null;
    }
}

// Search Function
var predictiveSearchInput = document.getElementById('searchInputField');
var timer;

var offcanvasSearch = document.getElementById('searchResult');
var bsOffcanvas = document.getElementById('searchResult');

if(predictiveSearchInput != null) {
    predictiveSearchInput.addEventListener('input', function(e) {

        clearTimeout(timer);

        if(predictiveSearchInput.value) {
            timer = setTimeout(fetchPredictiveSearch, 500);
        }
        
    });
}

function fetchPredictiveSearch() {
    fetch(`/search/suggest.json?q=${predictiveSearchInput.value}&resources[type]=product`)
    .then(resp => resp.json())
    .then(data => { 
        console.log(data);

        var products = data.resources.results.products;

        document.getElementById('search_results_body').innerHTML = '';

        products.forEach(function(product, index) {
            document.getElementById('search_results_body').innerHTML += `
                <a href="${product.url}">
                    <div class="flex items-start mb-10" style="w-320">
                    <img src="${product.image}" class="w-100">
                    <div class="ml-10">
                        <p class="uppercase mt-0 mb-5">${product.title}</p>
                        <p class="m-0" style="color:#edd100;">$${product.price}</p>
                    </div>
                </div>
                </a>
            `
        });
        bsOffcanvas.classList.add("block");
    });
}

function openSearch() {
  searchWrapper.classList.toggle("shown");
  searchInner.classList.toggle("shown-2");
}

function removeSearch() {
  searchWrapper.classList.remove("shown");
  searchInner.classList.remove("shown-2");
}

// Currency Change
function currencyFormSubmit(event) {
  event.target.form.submit();
}

  document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
    element.addEventListener('change', currencyFormSubmit);
  });



// Mobile Nav toggle open
document.querySelector("#toggle").addEventListener("click", function() {
  document.querySelector("#overlay").classList.toggle("open");
});

document.querySelector("#toggle-mobile").addEventListener("click", function() {
  document.querySelector("#overlay").classList.toggle("open");
});
// Tabs

function activateTabs(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-contents");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tab-button");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";
}


// Define variables
var tabLabels = document.querySelectorAll("#tabs li");
var tabPanes = document.getElementsByClassName("tab-contents");

function activateTab(e) {
  e.preventDefault();
  
  // Deactivate all tabs
  tabLabels.forEach(function(label, index){
    label.classList.remove("active");
  });
  [].forEach.call(tabPanes, function(pane, index){
    pane.classList.remove("active");
  });
  
  // Activate current tab
  e.target.parentNode.classList.add("active");
  var clickedTab = e.target.getAttribute("href");
  document.querySelector(clickedTab).classList.add("active");
}

  // Apply event listeners
  tabLabels.forEach(function(label, index){
    label.addEventListener("click", activateTab);
  });





// Fade in For Sections

// let elementsArray = document.querySelectorAll(".shopify-section");
// console.log(elementsArray);
// window.addEventListener('scroll', fadeIn ); 
// function fadeIn() {
//     for (var i = 0; i < elementsArray.length; i++) {
//         var elem = elementsArray[i]
//         var distInView = elem.getBoundingClientRect().top - window.innerHeight + 50;
//         if (distInView < 0) {
//             elem.classList.add("inView");
//         } else {
//             elem.classList.remove("inView");
//         }
//     }
// }
// fadeIn();

